// extracted by mini-css-extract-plugin
export default {"label":"V55n1BfT","borderer":"MCD8uwcL","input":"hc75MI0L","icons":"GSKU2EsW"};